import { Route, Routes } from "react-router-dom";
import PunchRecordsPage from "./Page";
import PunchRecordsFormIndex from "./Form";

export default function PunchRecordsIndex() {
  return (
    <Routes>
      <Route path="/" element={<PunchRecordsPage />}>
        <Route path="/punch-records" element={<PunchRecordsPage />} />
        <Route path="/:punchRecordId" element={<PunchRecordsFormIndex />} />
      </Route>
    </Routes>
  )
}
